
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DlgAdvisorNew from '@/modules/admin/advisors/_components/DlgAdvisorNew.vue';
  import DlgAdvisorsDelete from '@/modules/admin/advisors/_components/DlgAdvisorDelete.vue';

  @Component({
    components: {DlgAdvisorsDelete, DlgAdvisorNew, Card},
  })
  export default class VCeos extends Vue {
    @Action('admin/advisors/read') private readAdvisors!: () => Promise<void>;
    @Getter('admin/advisors/all') private advisors!: any;

    private headers: any = [
      {
        text: 'Name',
        align: 'left',
        value: 'username',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
      },
      {
        text: 'Status',
        align: 'left',
        value: 'status',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      try {
        await this.readAdvisors();
        this.loading = false;
      } catch (err: any) {
        this.loading = false;
      }
    }
  }
